module.exports = __webpack_public_path__ + "static/gray_ooze-cdced20358a617afb4b4bca06c2f3363.jpeg";